export default __webpack_public_path__ + "static/media/number-of-staffs.8ad700e3.png";